export enum MODAL_SIZES {
  xSmall = 400,
  small = 512,
  medium = 640,
  large = 768,
  xLarge = 896,
}

// DS Modal only allows 3 sizes, so we map whatever size was given to one of those
export const getDSMappedSizeFromValue = (size: number): 's' | 'm' | 'l' => {
  if (size < 450) {
    return 's';
  }
  if (size >= 450 && size <= 650) {
    return 'm';
  }
  return 'l';
};
